<template>
  <div
    id="createArticleFormContainer"
    class="flexContainer yCenterContainer columnContainer"
  >
    <button class="closeButton" @click="cancelCreateArticle">x</button>
    <div style="width: 90%" class="flexContainer columnContainer">
      <p>Wspaniale! Tu powstaje nowe znaczenie dla:</p>
      <p id="newArticleTitle">{{ selectedWords }}</p>
      <div class="flexContainer columnContainer">
        <div>
          <div class="flexContainer createArticleFormElementContainer">
            <label for="articleTitle">Tytuł</label>
            <input
              style="padding-left: 1%"
              class="newArticleFormField"
              id="articleTitle"
              v-model="title"
              :placeholder="articleTitlePlaceholder"
              autocomplete="off"
            />
          </div>
          <div class="flexContainer createArticleFormElementContainer">
            <label>Treść</label>
            <button
              @click="setType($event, 'TEXT')"
              class="newArticleFormField"
              :class="{ selectedArticleType: isText }"
            >
              tekst
            </button>
            <button
              @click="setType($event, 'MEDIA')"
              class="newArticleFormField"
              :class="{ selectedArticleType: isMedia }"
            >
              media
            </button>
            <button
              @click="setType($event, 'OTHER_ARTICLE')"
              class="newArticleFormField"
              :class="{ selectedArticleType: isOtherArticle }"
            >
              inny artykul
            </button>
          </div>
        </div>
        <component
          style="height: 200px; padding: 1%; font-size: 0.5em"
          class="newArticleFormField"
          v-bind:is="formType"
          @form_update_notification="updateDataFromForm($event)"
        ></component>
        <button
          id="createArticleButton"
          class="createArticleFormElementContainer linkAlike"
          @click="createArticle"
          :disabled="createDisabled"
        >
          Wspaniale!
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MediaForm from "./forms/media.vue";
import SearchForm from "./forms/search.vue";
import TextForm from "./forms/text.vue";

export default {
  components: {
    "text-form": TextForm,
    "media-form": MediaForm,
    "search-form": SearchForm,
  },
  props: {
    selectedWordsIndexes: Array,
    selectedWords: String,
    createFromArticle: Number,
    selectedParagraphId: Number,
  },
  data() {
    return {
      title: "",
      data: "",
      articleType: "TEXT",
      selectedArticleId: null,
    };
  },
  watch: {
    isCaptchaVerified(newValue) {
      if (!this.createDisabled && newValue === true) {
        this.postArticleData();
        this.$store.dispatch("resetCaptcha");
      }
    },
    articleType(newValue, oldValue) {
      if (oldValue === "OTHER_ARTICLE") {
        this.title = "";
      }
      this.data = "";
    },
  },
  mounted() {
    this.$emit("create_article_form_ready");
  },
  computed: {
    createDisabled() {
      if (this.isOtherArticle) {
        return this.selectedArticleId === null;
      } else {
        return this.title === "" || this.data === "";
      }
    },
    articleTitlePlaceholder() {
      return this.isOutside ? "tutaj wpisz link" : "tutaj wpisz tytul";
    },
    isCaptchaVerified() {
      return this.$store.getters.isCaptchaVerified;
    },
    isText() {
      return this.articleType === "TEXT";
    },
    isMedia() {
      return this.articleType === "MEDIA";
    },
    isOtherArticle() {
      return this.articleType === "OTHER_ARTICLE";
    },
    formType() {
      if (this.isText) {
        return "text-form";
      } else if (this.isMedia) {
        return "media-form";
      } else if (this.isOtherArticle) {
        return "search-form";
      } else {
        return "text-form";
      }
    },
  },
  methods: {
    updateDataFromForm(receivedData) {
      if (this.isText) {
        this.data = receivedData;
      } else if (this.isMedia) {
        this.data = receivedData;
      } else if (this.isOtherArticle) {
        this.title = receivedData.articleTitle;
        this.selectedArticleId = receivedData.articleId;
      }
    },
    setType(event, value) {
      event.preventDefault();
      this.articleType = value;
    },
    createLinks(articleToId) {
      this.$http
        .post("links/", JSON.stringify(this.buildLinksData(articleToId)))
        .then(() => {
          this.$store.dispatch("deletePopupMessage");
          this.$emit("load_new_article_data");
        });
    },
    createArticle() {
      if (process.env.NODE_ENV === "development") {
        this.postArticleData();
      } else {
        this.doCaptcha();
      }
    },
    postArticleData() {
      let formData = null;
      if (this.isOtherArticle) {
        this.createLinks(this.selectedArticleId);
      } else {
        if (this.isText) {
          formData = { title: this.title, content_data: this.data };
        } else if (this.isMedia) {
          formData = { title: this.title, media_data: this.data };
        }
        this.$http.post("articles/", formData).then(
          (createNewArticleResponse) => {
            this.createLinks(createNewArticleResponse.body.id);
          },
          (error) => {
            this.handlePostArticleDataError(error);
          }
        );
      }
    },
    handlePostArticleDataError(error) {
      this.articleType = "TEXT";
      this.$store.dispatch("sendNewPopupMessage", {
        type: "pop-up-error",
        data: error,
      });
    },
    cancelCreateArticle() {
      this.$emit("cancel_create_article");
    },
    doCaptcha() {
      this.$store.dispatch("sendNewPopupMessage", {
        type: "pop-up-do-captcha",
      });
    },
    buildLinksData(articleToId) {
      let linksData = [];
      for (let i in this.selectedWordsIndexes) {
        linksData.push({
          paragraph: this.selectedParagraphId,
          article_to: articleToId,
          word_index: this.selectedWordsIndexes[i],
        });
      }

      return linksData;
    },
  },
};
</script>

<style scoped>
#createArticleFormContainer {
  width: 100%;
  background-color: #03009a;
}

#newArticleTitle {
  align-self: center;
  color: #ffffff !important;
  text-decoration: underline;
}

#createArticleFormContainer p,
label {
  color: #ffae00;
  font-size: 0.5em;
}

.newArticleFormField,
#createArticleFormContainer input {
  background-color: #03009a;
  padding: 0;
  margin: 0;
  border: 1px solid #958efb;
  color: #ffffff;
}

.createArticleFormElementContainer {
  margin-top: 0.4em;
  margin-bottom: 0.4em;
  width: 100%;
}

label {
  width: 10%;
}

input {
  width: 90%;
  font-size: 0.5em;
}

.createArticleFormElementContainer button {
  width: 20%;
  font-size: 0.5em;
}

.selectedArticleType {
  color: #03009a;
  background-color: #ffaf60;
}

#createArticleButton {
  align-self: center;
  width: 20%;
  color: #ffae00;
  font-size: 0.5em
}

#createArticleButton:disabled {
  color: grey;
  cursor: none;
}
</style>
